import { autoCapitalize } from '@/utils/autoCapitalize'
import { IEnumResponse } from '@/types'
import { EnumToDropdownDataMapperConfigObject } from './EnumToDropdownDataMapper.types'

const DEFAULT_CONFIG = {
  autoCapitalize: true,
}

class EnumToDropdownDataMapper {
  toDomain(
    persistenceData: IEnumResponse,
    config: EnumToDropdownDataMapperConfigObject = DEFAULT_CONFIG,
  ) {
    return {
      value: String(persistenceData?.key),
      label: config?.autoCapitalize
        ? autoCapitalize(persistenceData?.value)
        : persistenceData?.value,
    }
  }
}

export default new EnumToDropdownDataMapper()
